import { Directive } from '@angular/core';
import { BrnDialogTitle } from '@spartan-ng/brain/dialog';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
    host: { 'data-slot': 'dialog-title' },
    hostDirectives: [BrnDialogTitle],
    selector: '[hlmDialogTitle]',
})
export class HlmDialogTitle {
    constructor() {
        classes(() => 'leading-none font-medium');
    }
}
